export default function formatRevisionVersion(version) {
    function capitalizeFirstLetter([first, ...rest]) {
        return [first.toUpperCase(), ...rest].join('')
    }

    if (!version) {
        return null
    }

    return capitalizeFirstLetter(`Rev ${version}`.replace(' v', ' '))
}
